export class functionpermission {
    fmsagencycreate: boolean = true;
    fmsagencyupdate: boolean = true;
    fmsagencydelete: boolean = true;
}

export class Fmsagency{
    id: string = "00000000-0000-0000-0000-000000000000";
    providerName: string ="";
    npi: string ="";
    phoneNumber: string ="";
    address: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    contactName: string ="";
    email: string ="";
    fax: string ="";
    fmsFee : number;
    statusLId: string="00000000-0000-0000-0000-000000000000";

}
export class getFmsagency {
currentpageno: number = 1;
  pageitem: number = 10;
  searchText: string;
  orderColumn: string = "providerName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "providerName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  statusLid: string="00000000-0000-0000-0000-000000000000";
}